import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import Project from '@/pages/Project'
import PrintResume from '@/pages/PrintResume'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '' + process.env.BASE_URL,
  routes: [
    { name: 'home', path: '/', component: Home },
    { name: 'project', path: '/projects/:id', component: Project, props: true },
    {
      name: 'print-resume',
      path: '/print-resume',
      meta: { layout: 'print' },
      component: PrintResume,
      props: (route) => ({
        ...route.params
      })
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js